<template>
    <div class="story-header-component">
        <div class="story-header-component__sticker" v-if="sticker">
            <div class="story-header-component__sticker-container">
                <div class="story-header-component__remove-sticker-button"
                     v-if="editMode"
                     tabindex="0"
                     role="button"
                     aria-label="Remove Sticker"
                     @click="removeSticker"
                     @keydown.enter="removeSticker"
                >
                    <i class="fa fa-times" aria-hidden="true"></i>
                </div>
                <render-sticker :sticker="sticker"></render-sticker>
            </div>
        </div>
        <div class="story-header-component__sticker-placeholder" v-if="editMode&&!sticker">
            <div class="story-header-component__attach_button story-header-component__attach_button_blue"
                 role="button"
                 aria-label="Add Sticker"
                 tabindex="0"
                 @click="addSticker"
                 @keydown.enter="addSticker"
            >
                <i class="far fa-thumbs-up" aria-hidden="true"></i>
                <i class="far fa-heart" aria-hidden="true"></i>
                <br>
                <span class="story-header-component__attach_button-label" aria-hidden="true">
                            + <span>Add</span> Sticker
                        </span>
            </div>
        </div>
        <div class="story-header-component__text-container" v-if="text&&!isHeader">
            <span v-html="textToDisplay"></span>
            <span class="story-header-component__round-edit-button"
                  v-if="editMode"
                  tabindex="0"
                  role="button"
                  aria-label="Edit Description"
                  @click="editDescription"
                  @keydown.enter="editDescription"
            >
                <i class="fa fa-pencil" aria-hidden="true"></i>
            </span>
        </div>
        <div class="story-header-component__text-container story-header-component__text-container_header"
             v-else-if="text&&isHeader">
            <span v-html="textToDisplay"></span>
            <span class="story-header-component__round-edit-button"
                  v-if="editMode"
                  tabindex="0"
                  role="button"
                  aria-label="Edit Description"
                  @click="editDescription"
                  @keydown.enter="editDescription"
            >
                <i class="fa fa-pencil" aria-hidden="true"></i>
            </span>
        </div>
        <div class="story-header-component__text-container story-header-component__text-container_add-holder"
             v-else-if="editMode">
            <div class="story-header-component__add-description-label"
                 tabindex="0"
                 role="button"
                 aria-label="Add Description"
                 @click="editDescription"
                 @keydown.enter="editDescription"
            >
                <i class="fa fa-plus"></i> Add description
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import RenderSticker from "../../add_media/stickers/render_sticker_directive/RenderSticker";
    import stickersFactory from "../../add_media/stickers/sticker_factory";
    import Autolinker from "autolinker";

    export default {
        name: "StoryHeader",
        components: {RenderSticker},
        props: {
            post: {
                type: Object,
                required: false,
            },
            editMode: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                text: '',
                isHeader: false,
                sticker: undefined,
            };
        },
        computed: {
            textToDisplay() {
                if (this.text) {
                    return Autolinker.link(this.text, {truncate: 30});
                } else {
                    return '';
                }
            }
        },
        methods: {
            dumpData() {
                return {
                    sticker: this.sticker ? this.sticker : null,
                    is_header: this.isHeader,
                    text: this.text,
                };
            },
            editDescription() {
                const addMedia = Vue.getAngularModule('addMedia');
                addMedia.add_text({text: this.text, is_header: this.isHeader}, true, true, 'Description')
                    .then(res => {
                        this.text = res.text;
                        this.isHeader = res.is_header;
                        this.onPostUpdate();
                    }, () => {
                    });
            },
            removeSticker() {
                this.sticker = undefined;
                this.onPostUpdate();
            },
            addSticker() {
                const stickersFactory = Vue.getAngularModule('stickersFactory');
                stickersFactory.select_sticker()
                    .then(sticker => {
                        this.sticker = sticker.code;
                        this.onPostUpdate();
                    }, cancel => {
                    });
            },
            onPostUpdate() {
                this.$emit('onPostUpdate', this.dumpData());
            },
            $_copyValues() {
                this.sticker = this.post?.sticker || undefined;
                this.text = this.post?.text || '';
                this.isHeader = this.post?.is_header || false;
            }
        },
        beforeMount() {
            this.$_copyValues();
        },
    };
</script>

<style scoped lang="scss">
  @import "../../styles/mixins";
  @import "../../styles/const";

  .story-header-component {
    text-align: center;

    &__sticker-container {
      display: inline-block;
      position: relative;
    }

    &__attach_button {
      padding: 3px;
      padding-top: 30px;

      height: 135px;
      width: 135px;
      line-height: 35px;
      display: inline-block;
      border-radius: 5px;
      font-size: 30px;

      &_blue {
        color: $blue;
        border: solid 3px $blue;
      }
    }

    &__attach_button-label {
      font-size: 18px;
      line-height: 20px;
    }

    &__text-container {
      @include wide_item_container(60px, 0);
      text-align: left;
      padding: 15px;
      margin-top: 15px;
      font-size: 18px;
      position: relative;

      &_header {
        font-size: 21px;
        line-height: 25px;
        font-weight: bolder;
        text-align: center;
      }

      &_add-holder {
        color: $tag-gray;
        font-size: 21px;
        line-height: 30px;
      }
    }

    &__add-description-label {
      cursor: pointer;
    }

    &__round-edit-button {
      position: absolute;
      right: 5px;
      top: 5px;
      width: 50px;
      height: 50px;
      font-size: 34px;
      line-height: 48px;
      text-align: center;
      color: white;
      display: inline-block;
      background-color: $gray;
      cursor: pointer;
      border-radius: 50%;
      transition: background-color 0.2s ease;

      &:focus, &:hover {
        background-color: $blue;
      }
    }

    &__remove-sticker-button {
      display: inline-block;
      color: $red;
      position: absolute;
      right: 1px;
      top: 1px;
      font-size: 33px;
      line-height: 40px;
      cursor: pointer;
      width: 40px;
      height: 40px;
    }

  }
</style>